import React from "react";
import Wishlist from "../components/Wishlist";
import { motion } from "framer-motion";
import { pageTransition, pageZoom } from "../utils/styleUtils";

function WishlistScreen() {
  return (
    <motion.div
      initial="initial"
      animate="in"
      exit="out"
      variants={pageZoom}
      transition={pageTransition}
    >
      <Wishlist />
    </motion.div>
  );
}
export default WishlistScreen;
